import Data from '../../common/data';
import { popMgr } from '../global';

const styleMap = {
    classic: () =>
        import(
            /* webpackChunkName: "common/questionnaire/classic"*/ './classic.vue'
        ),
    standard: () =>
        import(
            /* webpackChunkName: "common/questionnaire/standard"*/ './standard.vue'
        ),
    fashion: () =>
        import(
            /* webpackChunkName: "common/questionnaire/fashion"*/ './fashion.vue'
        ),
    broker: () =>
        import(
            /* webpackChunkName: "common/questionnaire/broker"*/ './broker.vue'
        )
};

const psMap = {};

const questionnaire = {
    prepare(vm, style = Data.questionNaire.style) {
        if (!psMap[style]) {
            psMap[style] = styleMap[style]();
            vm = vm || window.siteAppVm;
            vm.$options.components['questionnaire-' + style] = styleMap[style];
        }
        return psMap[style];
    },
    open(vm, options = {}, type = 0, style, bind = false) {
        style = style || Data.questionNaire.style || 'standard';
        const vdata = {
            name: 'questionnaire',
            type,
            options: bind
                ? options
                : Object.assign({}, Data.questionNaire, options)
        };
        // popData.vdata = vdata;
        this.prepare(vm, style).then(pop => {
            popMgr.create(pop.default, vdata);
        });
    }
};

export default questionnaire;
